import { serializePrivateProperties } from '../../utils/object_utils';

export const execute = (processInstanceData) => {
	return Promise.resolve(buildActivityBlockedMessages(processInstanceData));
};

const buildActivityBlockedMessages = (processInstanceData) => {
	const { concentrator } = processInstanceData;
	return (!!concentrator)
	? buildConcentratorActivityBlockedMessages(processInstanceData)
	: buildOtherActivityBlockedMessages(processInstanceData);
};

const buildConcentratorActivityBlockedMessages = (processInstanceData) => {
	const messages = [];
	messages.push(buildMessageObject('activity.messages.concentratorActivity'));
	messages.push(buildMessageObject('activity.messages.concentratorActivityWithPendingActivities'));

	return buildMessages(serializePrivateProperties(processInstanceData), messages);
};

const buildOtherActivityBlockedMessages = (processInstanceData) => {
	const messages = [];
	messages.push(buildMessageObject('activity.messages.activityBlocked'));

	return buildMessages(serializePrivateProperties(processInstanceData), messages);
};

const buildMessages = (processInstanceData, messages) => {
	return [ { processInstanceData, messages } ];
};

const buildMessageObject = (messageKey, htmlSafe = false) => {
	return { message: Realize.i18n.t(messageKey), htmlSafe };
};

export default {
	execute
};
